import React from 'react'
import { useHistory } from 'react-router-dom'
import { useClientOptions } from '@paintscout/ui-business'
import EditContact from './EditContact'

function EditContactWrapper(props) {
  const { options } = useClientOptions()
  const hidePeople = options.options.quotes.forceIntegrationContacts

  const history = useHistory()
  if (hidePeople) {
    history.push('/')
  } else {
    return <EditContact {...props} />
  }
}
export default EditContactWrapper
